import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative pt-14 pb-10 px-6 md:px-12 max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-52">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="mb-8 inline-flex items-center gap-2 px-4 py-1.5 border border-gold/40 rounded-full bg-white/50" data-id="element-53">
        <span className="w-2 h-2 rounded-full bg-gold animate-pulse" data-id="element-54"></span>
        <span className="text-xs font-semibold tracking-widest uppercase text-charcoal-light" data-id="element-55">
          Investigación Independiente
        </span>
      </motion.div>

      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.4
    }} className="text-4xl md:text-5xl lg:text-6xl font-serif leading-tight md:leading-tight text-charcoal max-w-4xl" data-id="element-56">
        Por qué la industria de la cosmética de $90 billones espera que{' '}
        <span className="italic text-gold-dark" data-id="element-57">nunca descubras</span> la
        verdadera causa de las arrugas
      </motion.h1>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 0.8
    }} className="mt-8 w-px h-14 bg-gradient-to-b from-gold to-transparent" data-id="element-58" />
    </section>;
}